import { DetailedList, FormBlock, FormCard } from '@qbe/ads-blocks-forms';
import { Box, Button, Link, Spacer, Stack, Typography } from '@qbe/ads-core';
import React, { useEffect } from 'react';

import { PAY_MY_BILL_ROUTE } from '~/constants/routes';
import { useAppContent, useAppDispatch, useAppSelector, usePayments } from '~/hooks';
import { useAppNavigate } from '~/hooks/useAppNavigate';
import { useTrackRenewalPaymentComplete } from '~/hooks/useTrackGoalMetrics';
import { navigateAction } from '~/thunks/navigateAction';
import { DateFormat, dateFormatter } from '~/utils';
import { currencyFormatter } from '~/utils/currencyFormatter';

const PayMyBillConfirmation: React.FC = () => {
  const { getTextContent: getSharedContent } = useAppContent({ basePath: 'shared' });
  const { getTextContent, getJSXContent } = useAppContent({
    basePath: 'dsme.payMyBillConfirmation',
  });

  const { policy } = useAppSelector((state) => state.payMyBill);
  const navigate = useAppNavigate();
  const { paymentReference, paymentState } = usePayments();
  const date = dateFormatter(new Date(), DateFormat.doMMMMyyyy);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (paymentState !== 'success') {
      dispatch(
        navigateAction({
          to: PAY_MY_BILL_ROUTE,
          navigate,
        })
      );
    }
  }, [dispatch, navigate, paymentState]);

  useTrackRenewalPaymentComplete();

  return (
    <Box data-testid="review-pay-payments">
      <FormCard description="" title={getTextContent('title')} variant="pageTitle">
        <Typography textAlign="center">
          {getJSXContent('content.description.description')}
        </Typography>
      </FormCard>
      <Spacer size="md" />
      <FormCard variant="content">
        <Typography textAlign="center" variant="h5">
          {getTextContent('fields.paymentSummary.title')}
        </Typography>
        <DetailedList
          sx={{ paddingLeft: '0px', paddingRight: '0px' }}
          list={[
            {
              id: 'paymentRef',
              label: getTextContent('fields.paymentSummary.reference'),
              name: 'paymentRef',
              value: paymentReference || '',
            },
            {
              id: 'amount',
              label: getTextContent('fields.paymentSummary.amount'),
              name: 'amount',
              value: currencyFormatter(policy?.dueAmount),
            },
            {
              id: 'paymentDate',
              label: getTextContent('fields.paymentSummary.date'),
              name: 'paymentDate',
              value: date,
            },
          ]}
          variant="multiple"
        />

        <FormBlock preset="button">
          <Stack direction="row" gap={2}>
            <Button
              component={Link}
              style={{
                marginRight: 'auto',
                alignSelf: 'start',
              }}
              onClick={() => {
                window.print();
                return false;
              }}
              data-track="print"
              label={getTextContent('buttons.print')}
              variant="primary-on-dark"
            />
            <Button
              variant="secondary-on-light"
              data-track={getSharedContent('homeButtonLabel')}
              onClick={() => {
                window.location.href = getSharedContent('qbeHome');
              }}
              label={getSharedContent('homeButtonLabel')}
              style={{ marginRight: 'auto' }}
            />
          </Stack>
        </FormBlock>
      </FormCard>
    </Box>
  );
};

export default PayMyBillConfirmation;
